import React from 'react'

const Menu = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
    <path d='M491.3 235.3H20.7C9.3 235.3 0 244.6 0 256s9.3 20.7 20.7 20.7h470.6c11.4 0 20.7-9.3 20.7-20.7C512 244.6 502.7 235.3 491.3 235.3z' />
    <path d='M491.3 78.4H20.7C9.3 78.4 0 87.7 0 99.1c0 11.4 9.3 20.7 20.7 20.7h470.6c11.4 0 20.7-9.3 20.7-20.7C512 87.7 502.7 78.4 491.3 78.4z' />
    <path d='M491.3 392.2H20.7C9.3 392.2 0 401.5 0 412.9s9.3 20.7 20.7 20.7h470.6c11.4 0 20.7-9.3 20.7-20.7S502.7 392.2 491.3 392.2z' />
  </svg>
)

export default Menu
